import styled from "styled-components";

interface IProps {
    name: string;
    Icons: any;
    value: number;
}

export default function AmountItems({
    name,
    Icons,
    value
}: IProps) {

    return (
        <Container>
            <LeftSection>
                {Icons}
                <Title>{name}</Title>
            </LeftSection>
            <Title>{value}</Title>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    
    padding: 8px;
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 12px;
`;

const LeftSection = styled.div`
    display: flex;
    gap: 4px;
    color: ${(props) => props.theme.colors.gray.gray_200};
    
    svg{
        color: ${(props) => props.theme.colors.primary};
    }
    `;

const Title = styled.p``;